define('modal',['dialog'], function(Dialog) {
    'use strict';

    var Modal = function(options) {
        options = options || {};

        options.dialog = options.dialog || document.getElementById('js-modal');
        options.mainClass = options.mainClass || 'modal';

        this.base = Dialog;
        this.base(options);

        this.overlay = (options.overlay === false) ? false : true;

        if (!this.dialog) {
            return;
        }

        if (!this.overlay) {
            this.dialog.className += ' no-overlay';
        }
    };

    Modal.prototype = new Dialog();

    return Modal;

});

